<!--suppress ALL -->
<template>
  <div class="order-details-dialog">
    <el-dialog
        v-loading="loading"
        :fullscreen="true"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
        :visible.sync="visible">
      <div
          id="replacement-request-title"
          class="replacement-request-title-bar"
          :class="{'eligibility-check-step': isActive0}">
        <button
            v-if="!showFinalStep"
            type="button"
            class="el-dialog__headerbtn"
            style="right: unset; left: 20px"
            aria-label="Back"
            @click="back">
          <i class="el-dialog__close el-icon el-icon-arrow-left"></i>
        </button>
        <div class="order-number">
          Replacement
        </div>
        <button
            type="button"
            class="el-dialog__headerbtn"
            aria-label="Close"
            @click="initiateClose">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
        <StepProgressBar
            v-if="!isActive0"
            :total-steps="progressBarSteps"
            :current-step="progressBarCurrentStep" />
      </div>
      <div
          v-if="!loading"
          id="replacement-request-body"
          class="replacement-request-body">
        <div class="replacement-request-steps">
          <StepFlowButton
              v-if="eligibilityCheckEnabled"
              buttontext="Eligibility Check"
              :isactive="isActive0"
              :current-value="0" />
          <StepFlowButton
              buttontext="Step 1: Review customer details"
              :isactive="isActive1"
              :current-value="1"
              @go-back="previous" />
          <StepFlowButton
              v-if="fulfillmentWarnActive"
              buttontext="Fulfillment Check"
              :isactive="isActive2"
              :current-value="2"
              @go-back="previous" />
          <StepFlowButton
              buttontext="Step 2: Select reason"
              :isactive="isActive3"
              :current-value="3"
              @go-back="previous" />
          <StepFlowButton
              buttontext="Step 3: Choose replacement"
              :isactive="isActive4"
              :current-value="4"
              @go-back="previous" />
          <StepFlowButton
              buttontext="Step 4: Submit replacement"
              :isactive="isActive5"
              :current-value="5"
              @go-back="previous" />
        </div>
        <div style="border: 1px solid #DEE5EC;"></div>
        <div
            id="replacement-request-data"
            class="replacement-request-data">
          <EligibilityCheck
              v-if="currentStep===0 && deviceOOWStatusVisible"
              :device="device"
              :eligibility="eligibility" />

          <BypassReason
              :v-if="currentStep===0 && bypassFormVisible"
              :bypass-form-visible.sync="bypassFormVisible"
              @set-bypass-reason="setBypassReason" />

          <ReviewCustomerDetailsAddress
              v-if="currentStep===1 && !isEditDetailsStep"
              :loading="loadingAddress"
              :edit-details.sync="isEditDetailsStep"
              :filled.sync="customerDetailsFilled"
              :customer="customerDetails"
              :address="customerAddress" />

          <div
              v-if="currentStep===1 && !isEditDetailsStep"
              class="expedited-shipping-option flex flex-auto flex-col">
            <div class="title">
              Shipping Options
            </div>
            <el-card
                shadow="never"
                style="width: 20rem;">
              <ExpeditedFormButton :expedited.sync="shippingOptions.expedited" />
            </el-card>
          </div>

          <EditCustomerDetail
              v-if="currentStep===1 && isEditDetailsStep"
              ref="editCustomer"
              :allvalid.sync="editCustomerEnableSave"
              :customer.sync="customerDetails"
              :address.sync="customerAddress" />

          <FulfillmentCheck
              v-if="currentStep===2"
              v-model="bypassFulfillment" />

          <ReplacementReasons
              v-if="currentStep===3"
              :device="device"
              :loading.sync="loading"
              :selected-group="selectedReasons.group"
              :selected-reason="selectedReasons.reason"
              @selected-group-and-reason="getSelectedReasons" />
          <ChooseReplacement
              v-if="currentStep===4"
              :device="device"
              :is-supervisor="isSupervisor"
              :selected-value="selectedValue"
              :skus="availableReplacements"
              :best-match="bestMatch"
              :expedited="shippingOptions.expedited"
              :country="customerAddress.country"
              :state="customerAddress.state"
              :replacement-search="replacementSearch"
              @set-replacement-search="setReplacementSearch"
              @set-selected-options="setSelectedOption" />
          <ReviewReplacementSummary
              v-if="currentStep===5 && !showFinalStep"
              :loading.sync="loading"
              :device="device"
              :replacement-product="selectedValue"
              :selected-name="selectedReasons.name"
              :customer="customerDetails"
              :first-setup-date="firstSetupDate"
              :address="customerAddress" />
          <ReplacementSummary
              v-if="currentStep===5 && showFinalStep"
              :loading.sync="loading"
              :device="device"
              :replacement-product="selectedValue"
              :selected-name="selectedReasons.name"
              :customer="customerDetails"
              :address="customerAddress"
              :first-setup-date="firstSetupDate"
              :replacement-id="replacementId"
              :created-on="createdOn"
              :needs-return-label="needsReturnLabel" />
        </div>
      </div>
      <div
          id="replacement-request-footer"
          class="replacement-request-footer">
        <el-checkbox
            v-show="showReturnSummaryConfirmationLink"
            v-model="isSummaryConfirmed"
            class="confirm-checkbox"
            style="margin-right: 24px">
          The items for return and address are correct.
        </el-checkbox>
        <el-checkbox
            v-if="showAddressConfirmationCheck"
            v-model="isConfirmed"
            class="confirm-checkbox"
            style="margin-right: 24px">
          Customer details and address are correct.
        </el-checkbox>
        <el-button
            v-show="showExit"
            class="action_button"
            @click="initiateClose">
          Exit
        </el-button>
        <el-button
            v-show="deviceOOWStatusVisible"
            class="action_button back"
            type="primary"
            @click="allowToBypass">
          Bypass
        </el-button>
        <el-button
            v-show="showCancel"
            class="action_button back"
            style="color: #1998d5 !important; margin-right: 2px;"
            @click="cancel">
          Cancel
        </el-button>
        <el-button
            v-show="showSaveChanges"
            type="primary"
            :disabled="!editCustomerEnableSave && !customerDetailsFilled"
            class="action_button"
            @click="saveChanges">
          Save Changes
        </el-button>
        <el-button
            v-show="showBack"
            class="action_button back"
            @click="back">
          Back
        </el-button>
        <el-button
            v-show="showNext"
            type="primary"
            :disabled="isNextDisabled"
            class="action_button"
            @click="next">
          Continue
        </el-button>
        <el-button
            v-show="currentStep === 5 && !showFinalStep"
            type="primary"
            :disabled="isSendReplacementLabelDisabled"
            class="action_button"
            @click="finalStep">
          Submit Replacement
        </el-button>
        <el-button
            v-show="currentStep === 5 && showFinalStep"
            type="primary"
            class="action_button"
            @click="exit">
          Done
        </el-button>
      </div>
    </el-dialog>
    <div>
      <ExitModal
          v-if="exitModalVisible"
          :visible.sync="exitModalVisible"
          @exit-replacement="confirmClose" />
    </div>
  </div>
</template>

<script>
import EditCustomerDetail from "./EditCustomerDetail.vue";
import ChooseReplacement from "./ChooseReplacement.vue";
import ReviewReplacementSummary from "./ReviewReplacementSummary.vue";
import ReplacementSummary from "./ReplacementSummary.vue";
import EligibilityCheck from "./EligibilityCheck.vue";
import FulfillmentCheck from "./FulfillmentCheck.vue";
import BypassReason from "./BypassReason.vue";
import ReviewCustomerDetailsAddress from "./ReviewCustomerDetailsAddress.vue";
import StepProgressBar from "../OrderWidget/StepProgressBar.vue";
import StepFlowButton from "../OrderWidget/Return/StepFlowButton.vue";
import ReplacementReasons from "./ReplacementReasons.vue";
import ExitModal from "../ExitModal.vue";
import TimeZoneFormatter from "@/helpers/TimeZoneFormatterHelper";
import axios from "axios";
import { head, isEmpty, orderBy, get, extend } from "lodash";

import {
  createNamespacedHelpers,
  createNamespacedHelpers as module,
} from "vuex";
import ExpeditedFormButton from "../RequestHelpers/ExpeditedFormButton.vue";
import { DeviceWarrantyAndEligibilityPolicy } from "@/helpers/DeviceWarrantyAndEligibilityPolicy";
import deliveryEstimates from "@/mixins/deliveryEstimates";
const { mapGetters: sharedGetters } = createNamespacedHelpers("shared");
const { mapGetters: deviceGetters, mapActions: deviceActions } =
  createNamespacedHelpers("db/device");
const { mapGetters: authGetters } = createNamespacedHelpers("auth");
const { mapGetters: accountGetters } = module("db/account");
const { mapActions: requestActions, mapMutations: requestMutations } =
  createNamespacedHelpers("db/requests");

export default {
  name: "ReplacementForm",
  components: {
    ExpeditedFormButton,
    ReplacementSummary,
    ReviewReplacementSummary,
    EditCustomerDetail,
    ReviewCustomerDetailsAddress,
    ChooseReplacement,
    StepProgressBar,
    StepFlowButton,
    ReplacementReasons,
    ExitModal,
    EligibilityCheck,
    FulfillmentCheck,
    BypassReason,
  },
  mixins: [deliveryEstimates],
  props: {
    device: {
      type: Object,
      required: true,
    },
    eligibility: {
      type: Object,
      required: false,
      default: () => {
        return DeviceWarrantyAndEligibilityPolicy.create(null);
      },
    },
    missingDeviceEligibility: {
      type: Object,
      required: false,
      default: () => {},
    },

    visible: {
      type: Boolean,
      default: false,
    },
    isSupervisor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shippingOptions: { expedited: false },
      loadingAddress: false,
      customerDetailsFilled: true,
      exitModalVisible: false,
      loading: false,
      currentStep: 1,
      totalSteps: 5,
      progressBarSteps: 4,
      isActive0: false,
      isActive1: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      isActive5: false,
      displayFinalStep: false,
      areReasonsSelected: false,
      reasons: {},
      selectedReasons: {
        group: -1,
        reason: -1,
        name: "",
        label: false,
      },
      selectedBypassReason: "",
      isConfirmed: false,
      isEditDetailsStep: false,
      editCustomerEnableSave: false,
      bypassFormVisible: false,
      isBypassReasonSelected: false,
      deviceOOWStatusVisible: false,
      fulfillmentWarnActive: false,
      deviceId: "",
      bypassFulfillment: false,
      needEligibilityBypass: false,
      customerDetails: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
      },
      customerAddress: {
        address1: "",
        address2: "",
        city: "",
        country: "",
        state: "",
        zip_code: "",
      },
      locationId: "",
      availableReplacements: [],
      bestMatch: {},
      selectedValue: {},
      replacementSearch: "",
      isSummaryConfirmed: false,
      replacementId: "",
      createdOn: "",
      missingDevice: false,
      needsReturnLabel: true,
    };
  },
  computed: {
    ...sharedGetters(["userHasPermission", "delayedFulfillmentEnabled"]),
    showExit() {
      return (
        this.deviceOOWStatusVisible ||
        (this.currentStep === 1 && !this.isEditDetailsStep)
      );
    },
    progressBarCurrentStep() {
      switch (this.currentStep) {
        case 1:
          return this.currentStep;
          break;
        default:
          return this.currentStep - 1;
      }
      return this.currentStep;
    },
    warranty() {
      return this.eligibility.warranty;
    },
    oowReason() {
      return this.warranty.notes;
    },
    isRestricted() {
      const { replacement } = this.eligibility;
      return replacement.isRestricted;
    },
    warrantyEndsAt() {
      return this.warranty.standardExpiration;
    },
    firstSetupDate() {
      return this.eligibility.warranty.activationDate;
    },
    ...accountGetters(["customerId", "customer", "locations"]),
    ...deviceGetters(["doorbotId"]),
    ...authGetters(["user"]),
    showSaveChanges() {
      return this.currentStep === 1 && this.isEditDetailsStep;
    },
    device_id() {
      return (
        get(this.device, "device_id", null) ||
        get(this.device, "mac_address", null) ||
        get(this.device, "hardware_id", null)
      );
    },
    showAddressConfirmationCheck() {
      return (
        this.currentStep === 1 &&
        !this.isEditDetailsStep &&
        this.customerDetailsFilled
      );
    },
    showBack() {
      return (
        this.currentStep > 1 &&
        !this.showCancel &&
        !this.displayFinalStep &&
        !this.isEditDetailsStep
      );
    },
    showNext() {
      return (
        (this.currentStep < 5 &&
          this.currentStep !== 0 &&
          !this.isEditDetailsStep) ||
        (this.currentStep === 0 && this.bypassFormVisible)
      );
    },
    bestMatchInStock() {
      return (
        !this.bestMatch.out_of_stock ||
        (this.bestMatch.out_of_stock && this.isSupervisor)
      );
    },
    isNextDisabled() {
      return (
        (this.currentStep === 0 && !this.isBypassReasonSelected) ||
        (this.currentStep === 3 && !this.areReasonsSelected) ||
        (this.currentStep === 1 &&
          (!this.isConfirmed || !this.customerDetailsFilled)) ||
        (this.currentStep === 4 &&
          !isEmpty(this.selectedValue) &&
          ((this.selectedValue.out_of_stock && !this.isSupervisor) ||
            this.selectedValue.shipping_eligible === false))
      );
    },
    showFinalStep() {
      return this.currentStep === 5 && this.displayFinalStep;
    },
    showCancel() {
      return (
        (this.currentStep === 1 && this.isEditDetailsStep) ||
        (this.currentStep === 0 && this.bypassFormVisible)
      );
    },
    showEditAddressConfirmationCheck() {
      return (
        this.currentStep === 1 &&
        this.isEditDetailsStep &&
        this.customerDetailsFilled
      );
    },
    showReturnSummaryConfirmationLink() {
      return this.currentStep === 5 && !this.displayFinalStep;
    },
    isSendReplacementLabelDisabled() {
      return this.currentStep === 5 && !this.isSummaryConfirmed;
    },
    eligibilityCheckEnabled() {
      return this.isSupervisor && this.isRestricted && !this.missingDevice;
    },
  },
  watch: {
    currentStep() {
      [0, 1, 2, 3, 4, 5].forEach((step) => {
        this[`isActive${step}`] = step === this.currentStep;
      });
    },
  },
  mounted() {
    // Check if device is deleted or unset
    this.deviceId = this.device.device_id || this.device.doorbot_id;

    // Init the steps requiered
    this.initializeSteps(this.deviceId);

    this.getCustomerDetails();
    if (!this.device.isAccessory) {
      this.loading = true;

      // Missing Device?
      if (this.deviceId === undefined) {
        this.missingDevice = true;
        this.loading = false;
        // Clear current customer to start Missing-Device Replacement Flow
        Object.assign(this.customerDetails, {
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
        });
      } else {
        axios
          .get(`v3/devices/${this.deviceId}`)
          .then((response) => {
            if (response.data) {
              this.locationId = response.data.device.location_id;
              this.device.profile.retailer = response.data.profile.retailer;
              if (response.data.profile.color) {
                this.device.profile.color = response.data.profile.color;
              }
              this.getCustomerAddress();
            } else {
              console.log("Invalid response");
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
  destroyed() {
    this.resetRequestFlow();
  },
  methods: {
    ...requestActions(["createRequest"]),
    ...requestMutations(["resetRequestFlow"]),
    ...deviceActions(["getDeviceEligibility"]),

    async recalculateDelayedFulfillmentStatus(country) {
      this.loading = true;
      const response = await this.getDeviceEligibility({
        customerId: this.deviceOwnerId(),
        deviceId: this.device_id,
        deviceLocationCountry: country,
      });
      const delayedStatus = get(response, "eligibility.is_delayed_fulfillment");
      if (delayedStatus !== undefined) {
        this.fulfillmentWarnActive = this.isDelayedFulfillmentVisible(
          this.device_id,
          delayedStatus
        );
      }
      this.loading = false;
    },

    async initializeSteps(deviceId) {
      const { replacement } = this.eligibility;

      // Await the fulfillment check
      this.fulfillmentWarnActive = this.isDelayedFulfillmentVisible(deviceId);

      // Check if eligibility bypass should be active
      this.needEligibilityBypass =
        replacement.isRestricted &&
        replacement.isUserAllowed &&
        deviceId !== undefined;

      // Set initial step
      switch (true) {
        case this.needEligibilityBypass:
          this.currentStep = 0;
          this.isActive0 = true;
          this.deviceOOWStatusVisible = true;
          break;
        default:
          this.currentStep = 1;
          this.isActive1 = true;
          break;
      }
    },
    isDelayedFulfillmentVisible(deviceId, newStatus) {
      switch (true) {
        case !this.delayedFulfillmentEnabled:
          return false;

        case deviceId === undefined:
          return this.missingDeviceEligibility.eligibility
            .is_delayed_fulfillment;

        default:
          const delayed =
            newStatus === undefined
              ? this.eligibility.isDelayedFulfillment
              : newStatus;
          return delayed && !this.eligibility.isAccessory;
      }
    },
    getBestMatchDevice() {
      axios
        .get(
          `/v2/customer_requests/load_replacements_options?device_id=${this.device_id}&country=${this.customerAddress.country}&state=${this.customerAddress.state}&bypass_filter=${this.isBypassReasonSelected}&color=undefined`
        )
        .then((response) => {
          const skus = get(response, "data.skus", []);
          if (!skus.length) {
            this.$notify.error({
              title: "Shipping Address not supported",
              message: "Replacement shipping not available for region.",
            });
            return;
          }

          const replacementOptions = orderBy(skus, ["priority"], ["asc"]);

          this.currentStep = this.currentStep + 1;
          for (let i = 0; i < replacementOptions.length; i++) {
            replacementOptions[i].type = replacementOptions[i].product.kind;
            replacementOptions[i].stock =
              replacementOptions[i].stock.toUpperCase();
            replacementOptions[i].ux_properties = { loading: false };
          }

          let availableReplacements = replacementOptions.filter((item) => {
            return (
              (item.priority > 0 &&
                !item.out_of_stock &&
                item.shipping_eligible) ||
              this.isSupervisor
            );
          });

          if (this.isSupervisor) {
            this.bestMatch = availableReplacements.find(
              (e) => e.best_match && e.shipping_eligible
            );
          } else {
            this.bestMatch = availableReplacements[0];
          }

          if (isEmpty(this.bestMatch)) this.bestMatch = {};
          if (isEmpty(this.selectedValue)) this.selectedValue = this.bestMatch;
          this.availableReplacements = availableReplacements;

          this.fetchDeliveryEstimates({
            country: this.customerAddress.country,
            postalCode: this.customerAddress.zip_code,
            items: availableReplacements,
            priorityItems: isEmpty(this.bestMatch) ? [] : [this.bestMatch],
          });
        })
        .catch((error) => {
          this.$notify.error({
            title: "Device Error",
            message:
              "An error occurred while fetching the replacement products of this device.",
          });
          console.log(error);
        });
    },
    getCustomerDetails() {
      const { first_name, last_name, email, phone_number, locations } =
        this.customer;
      Object.assign(this.customerDetails, {
        first_name,
        last_name,
        email,
        phone_number,
      });
      if (this.device.isAccessory) {
        const { address1, address2, city, state, zip_code, country } =
          locations[0].address;
        Object.assign(this.customerAddress, {
          address1,
          address2,
          city,
          state,
          zip_code,
          country,
        });
      }
    },
    getCustomerAddress() {
      if (this.device.isAccessory || this.missingDevice) {
        return;
      }
      this.loadingAddress = true;
      let locationPath = `locations/device/${this.device.doorbot_id}/location/${this.locationId}`;
      axios
        .get(locationPath)
        .then((response) => {
          Object.assign(
            this.customerAddress,
            response.data.device_location.address
          );
        })
        .catch((error) => {
          this.$notify.error({
            title: "Device Location Error",
            message:
              "An error occurred while fetching the location of this device.",
          });
          console.log(error);
        })
        .finally(() => {
          this.loadingAddress = false;
        });
    },
    previous(clickedValue) {
      if (this.currentStep === this.totalSteps && this.displayFinalStep) return;
      if (clickedValue < this.currentStep) {
        this.currentStep = clickedValue;
      }
    },
    initiateClose() {
      if (this.displayFinalStep) {
        this.exit();
      } else {
        this.exitModalVisible = true;
      }
    },
    confirmClose(closeBoolean) {
      this.exitModalVisible = !!!closeBoolean;
      this.$emit("update:visible", !!!closeBoolean);
    },
    exit() {
      this.$emit("update:visible", false);
    },
    back(event) {
      event.target.blur();
      switch (true) {
        case this.currentStep === 0 || this.currentStep === 1:
          this.initiateClose();
          break;
        case this.isEditDetailsStep:
          this.isEditDetailsStep = false;
          this.currentStep = 1;
          break;
        case this.currentStep === 3 && !this.fulfillmentWarnActive:
          this.currentStep = 1;
          break;
        default:
          this.currentStep = this.currentStep - 1;
          break;
      }
    },
    next(event) {
      event.target.blur();
      switch (this.currentStep) {
        case 0:
          this.bypassFormVisible = false;
          this.currentStep = 1;
          break;
        case 1:
          this.currentStep = this.fulfillmentWarnActive
            ? this.currentStep + 1
            : this.currentStep + 2;
          break;
        case 3:
          this.getBestMatchDevice();
          break;
        default:
          this.currentStep++;
          break;
      }
    },
    allowToBypass() {
      this.deviceOOWStatusVisible = false;
      this.bypassFormVisible = true;
    },
    cancel() {
      if (this.currentStep === 1 && this.isEditDetailsStep) {
        this.isEditDetailsStep = false;
        this.editCustomerEnableSave = false;
        this.isConfirmed = false;
      } else if (this.currentStep === 0) {
        this.initiateClose();
      }
    },
    setBypassReason(reason) {
      this.isBypassReasonSelected = true;
      this.selectedBypassReason = reason;
    },
    saveChanges() {
      this.$refs.editCustomer.saveChanges();
      this.recalculateDelayedFulfillmentStatus(this.customerAddress.country);
      this.isEditDetailsStep = false;
    },
    getSelectedReasons(selectedReason) {
      this.areReasonsSelected = selectedReason.allowNext;
      this.selectedReasons = {
        group: selectedReason.group,
        reason: selectedReason.reason,
        name: selectedReason.name,
        label: selectedReason.label,
      };
    },
    setSelectedOption(option) {
      this.selectedValue = option;
    },
    setReplacementSearch(replacementSearch) {
      this.replacementSearch = replacementSearch;
    },
    finalStep() {
      this.loading = true;
      let payload = this.createPayload();
      this.createRequest(payload)
        .then((response) => {
          if (response.data) {
            this.needsReturnLabel = response.data.needs_return_label;
            this.replacementId = response.data.uuid;
            this.createdOn = TimeZoneFormatter.formattedTime(
              response.data.created_at
            );
          } else {
            console.log("Invalid response");
          }
        })
        .catch((error) => {
          this.$forEachPlcError(error, (msg) => {
            this.$notify({ type: "error", message: msg });
          });
        })
        .finally(() => {
          this.loading = false;
          this.displayFinalStep = true;
        });
    },
    deviceOwnerId() {
      if (this.device.owner_id !== undefined) {
        //Return Device Owner
        return this.device.owner_id;
      } else {
        //Return Current Customer as Owner for a Missing Device
        return this.customerId;
      }
    },
    createPayload() {
      let fullName =
        this.customerDetails.first_name + ", " + this.customerDetails.last_name;

      // Defensive validation: Ensure profile_id matches the device we're working with
      const profileDeviceId = get(this.device, "profile.device_id");
      const currentDeviceId = this.device.device_id || this.device_id;

      if (
        profileDeviceId &&
        currentDeviceId &&
        profileDeviceId !== currentDeviceId
      ) {
        console.warn(
          `Profile device_id mismatch detected! Profile: ${profileDeviceId}, Current Device: ${currentDeviceId}. ` +
            `This may indicate a data consistency issue.`
        );
      }

      let customer_request = {
        admin_user_id: this.user.id,
        customer_address_1: this.customerAddress.address1,
        customer_address_2: this.customerAddress.address2,
        customer_city: this.customerAddress.city,
        customer_country: this.customerAddress.country,
        customer_email: this.customerDetails.email,
        customer_name: fullName,
        customer_phone: this.customerDetails.phone_number,
        customer_request_reasons_attributes: [
          {
            reason_id: this.selectedReasons.reason,
            quantity: 1,
          },
        ],
        customer_state: this.customerAddress.state,
        customer_zip: this.customerAddress.zip_code,
        old_device_id: this.device.device_id,
        device_kind: this.device.type,
        device_price: this.selectedValue,
        return_label: this.selectedReasons.label,
        type: "CustomerRequest::Replacement",
        requested_by_area: "customer_support",
        owner_id: get(this.device, "isAccessory", false)
          ? this.customerId
          : this.deviceOwnerId(),
        profile_id: this.device.profile.id,
        new_device_kind: this.selectedValue.product.kind,
        new_device_color: this.selectedValue.color,
        expedited: this.shippingOptions.expedited,
        bypass_fulfillment_resolution: !this.eligibility.isAccessory
          ? this.bypassFulfillment
          : undefined,
      };

      if (this.isBypassReasonSelected) {
        extend(customer_request, {
          oow_bypass_reason: this.selectedBypassReason,
        });
      }
      return customer_request;
    },
  },
};
</script>

<style lang="scss" scoped>
.replacement-request-dialog {
  .el-dialog el-dialog__header {
    padding: 0 !important;
    width: 100%;
    display: none !important;
  }

  .el-dialog el-dialog__body {
    padding: 0 !important;
    height: inherit;
  }
}
.eligibility-check-step {
  box-shadow: 0px -1px 0px 0px #dee5ec inset;
}
.replacement-request-title-bar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9;
  height: 64px;
  background: #ffffff;

  .order-number {
    position: absolute;
    height: 24px;
    left: 72px;
    right: 72px;
    top: calc(50% - 24px / 2);

    /* body/normal-medium */

    font-family: "Equip", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    display: table-cell;
    align-items: center;
    text-align: center;

    /* 🖥 light/content/base */
    color: #424242;
  }
}
.replacement-request-body {
  top: 64px;
  bottom: 64px;
  margin-bottom: 64px;
  position: relative;
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  min-height: calc(100% - 160px);
  background: rgb(250, 251, 252);
  padding-bottom: 74px;

  .replacement-request-steps {
    width: 532px;
    flex: 1;
    background: #ffffff;
    padding: 40px;
  }
  .replacement-request-data {
    flex: 3;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    padding: 40px;
    .expedited-shipping-option {
      gap: 8px;
      .title {
        color: #6e6e6e;
        font-weight: 500;
        line-height: 24px;
      }
    }
  }
}
.replacement-request-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  height: 64px;
  background: #ffffff;
  filter: drop-shadow(0px -1px 4px rgba(0, 0, 0, 0.15));
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 40px;
}

.action_button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px !important;
  gap: 8px;
  width: 277px;
  height: 48px;
  flex: none;
  order: 0;
  flex-grow: 0;
  border: 1px solid #1998d5 !important;
  border-radius: 8px !important;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 28px !important;
  text-align: center !important;

  .back {
    color: #1998d5 !important;
  }
}
</style>
